module.exports = __webpack_public_path__ + "img/Circle_Arrow.011c2d33.svg";